export function convertCyrillicToLatin(text) {
  return text
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "") // премахва диакритики (напр. й като й)
    .replaceAll("ч", "ch")
    .replaceAll("ш", "sh")
    .replaceAll("щ", "sht")
    .replaceAll("ю", "yu")
    .replaceAll("я", "ya")
    .replaceAll("ж", "zh")
    .replaceAll("а", "a")
    .replaceAll("б", "b")
    .replaceAll("в", "v")
    .replaceAll("г", "g")
    .replaceAll("д", "d")
    .replaceAll("е", "e")
    .replaceAll("з", "z")
    .replaceAll("и", "i")
    .replaceAll("й", "y")
    .replaceAll("к", "k")
    .replaceAll("л", "l")
    .replaceAll("м", "m")
    .replaceAll("н", "n")
    .replaceAll("о", "o")
    .replaceAll("п", "p")
    .replaceAll("р", "r")
    .replaceAll("с", "s")
    .replaceAll("т", "t")
    .replaceAll("у", "u")
    .replaceAll("ф", "f")
    .replaceAll("х", "h")
    .replaceAll("ъ", "a")
    .replaceAll("ь", "")
    .replaceAll("Ч", "Ch")
    .replaceAll("Ш", "Sh")
    .replaceAll("Щ", "Sht")
    .replaceAll("Ю", "Yu")
    .replaceAll("Я", "Ya")
    .replaceAll("Ж", "Zh")
    .replaceAll("А", "A")
    .replaceAll("Б", "B")
    .replaceAll("В", "V")
    .replaceAll("Г", "G")
    .replaceAll("Д", "D")
    .replaceAll("Е", "E")
    .replaceAll("З", "Z")
    .replaceAll("И", "I")
    .replaceAll("Й", "Y")
    .replaceAll("К", "K")
    .replaceAll("Л", "L")
    .replaceAll("М", "M")
    .replaceAll("Н", "N")
    .replaceAll("О", "O")
    .replaceAll("П", "P")
    .replaceAll("Р", "R")
    .replaceAll("С", "S")
    .replaceAll("Т", "T")
    .replaceAll("У", "U")
    .replaceAll("Ф", "F")
    .replaceAll("Х", "H")
    .replaceAll("Ъ", "A")
    .replaceAll("Ь", "")
    .replaceAll("\u0456", "i") // кирил. украинско "і"
    .replaceAll("\u0406", "I") // главна "І"
    .replaceAll("\u0414", "D")
    .replaceAll("\u0422", "T")
    .replaceAll("\u0418", "I");
}

export function generateImageURL(car) {
  const model = convertCyrillicToLatin(car.model)
    .toLowerCase()
    .replaceAll(" ", "")
    .replaceAll("/", "")
    .replaceAll("-", "");

  const body = convertCyrillicToLatin(car.body)
    .toLowerCase()
    .replaceAll(" ", "")
    .replaceAll("/", "")
    .replaceAll("-", "");

  const trim = convertCyrillicToLatin(car.trim)
    .toLowerCase()
    .replaceAll(" ", "")
    .replaceAll("/", "")
    .replaceAll("-", "");

  const color = convertCyrillicToLatin(car.color)
    .toLowerCase()
    .replaceAll(" ", "")
    .replaceAll("/", "")
    .replaceAll("-", "");

  return `/images/${model}-${body}-${trim}-${color}.jpeg`;
}
